export class Configuration {
    apiKey: string;
    username: string;
    password: string;
    accessToken: string | (() => string);
}


// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/api/configuration.ts